const jwt = require("jsonwebtoken");
import objectHash from "object-hash";

const state = () => ({
	loading: [],
	flagStatusHashSet: {},
	individualGroups: [],
	authToken: "",
	entityUuid: "",
});

const mutations = {
	reset(state) {
		state.loading = [];
	},
	setFlagStatus(state, payload) {
		Object.assign(state.flagStatusHashSet, payload);
		this.$featureFlag.log(JSON.stringify(state.flagStatusHashSet, null, 2));
	},
	setLoading(state, payload) {
		state.loading.push(payload.key);

		// unique the array
		state.loading = [...new Set(state.loading)];

		// remove
		if (!payload.value) {
			state.loading = state.loading.filter((e) => e !== payload.key);
		}
	},
	setIndividualGroups(state, payload) {
		state.individualGroups = payload;
	},
	setAuthToken(state, payload) {
		state.authToken = payload;
	},
	setEntityUuid(state, payload) {
		state.entityUuid = payload;
	},
};

const actions = {
	async init(context) {
		const authToken = this.$cookies.get(`auth._token.uptogether`);
		const decodedToken = jwt.decode(authToken);
		// Decoded token can be null if the user is not logged in
		const entityUuid = decodedToken ? decodedToken.identity.entity_uuid : null;
		context.commit("setAuthToken", authToken);
		context.commit("setEntityUuid", entityUuid);
	},
	async getIndividualGroups(context, payload = {}) {
		try {
			const query = `
				query authGroup{
					me {
						authGroup {
							entityUuid
							name
						}
					}
				}`;
			const response = await this.$axios.post("/GRAPHQL_URL/", {
				query,
			});
			if (response.status == 200 && !response.errors) {
				const entity = response.data.data.me;
				const authGroups = entity.authGroup.map((x) => x.name);
				context.commit("setIndividualGroups", authGroups);
			} else {
				this.$featureFlag.error("Error in fetching individual groups", response.errors);
			}
		} catch (error) {
			this.$featureFlag.error("Error fetching individual groups", error);
		}
	},
	async getFlagStatus(context, args) {

		let flags = args.flags;
		const bypassCache = args.bypassCache;

		let flagStatus = {};
		let hashesToUpdate = {};

		const hash = (obj) => {
			return objectHash(obj);
		}


		try {
			context.commit("setLoading", { key: "featureFlag", value: true });

			if (context.state.individualGroups.length == 0) {
				await context.dispatch("getIndividualGroups");
			}

			const flagsToCheck = flags.reduce((acc, flag) => {
				const { name, extra_data, override, fallbackBehavior } = flag;
				const { key, ...extras } = extra_data;

				let payload = {
					name: name,
					key: key,
					data: extras,
				};

				if (!override) {
					payload.key = context.state.entityUuid;
					payload.data = {
						...payload.data,
						entityUuid: [context.state.entityUuid],
						authGroup: context.state.individualGroups,
					};
				}

				const payloadHash = hash(payload).toString();

				if (context.state.flagStatusHashSet.hasOwnProperty(payloadHash)) {
					// if the flag is already in the hash set
					const cachedFlag = context.state.flagStatusHashSet[payloadHash];
					flagStatus[name] = cachedFlag.value;
				} else { 
					// if the flag is not in the hash set
					flagStatus[name] = fallbackBehavior;
					hashesToUpdate[name] = payloadHash;
					acc.push(payload);
				}

				return acc;
			 }, []);

			if (flagsToCheck.length > 0) {
				let config = {}
				if (bypassCache) { 
					config["headers"] = {"Cache-Control": "max-age=0"};
				}

				// Refreshing token before query get flag value
				await context.dispatch("fiiAuth/refreshToken", {}, { root: true });

				const response = await this.$axios.$post(`/AUTH_URL/get-flag-value`, flagsToCheck, config);
				
				let flagStatusHashSetToUpdate = {};
				flagStatus = response.RESULTS.reduce((acc, curr) => {

					const payloadHash = hashesToUpdate[curr.flag];

					flagStatusHashSetToUpdate[payloadHash] = {
						name: curr.flag,
						value: curr.value,
					}

					return { ...acc, [curr.flag]: curr.value }

				}, flagStatus);

				context.commit("setFlagStatus", flagStatusHashSetToUpdate);
				return flagStatus;
			}

			return flagStatus;
		} catch (error) {
			this.$featureFlag.error("Error in getFlagStatus", error);
			const errorResponse = flags.reduce((acc, flag) => ({ ...acc, [flag.name]: flag.fallbackBehavior }), flagStatus);
			// Flag to indicate a error occurred
			errorResponse.hasError=true;
			return errorResponse;
		} finally {
			context.commit("setLoading", { key: "featureFlag", value: false });
		}
	},
};

const getters = {
	loading(state) {
		return state.loading.length !== 0;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
